import { SVGIconComponent } from './types';

export const Unknown: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ color, ...style }}
    className={className}
  >
    <g id="Type/Unknown" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M12,0 C18.6168,0 24,5.3832 24,12 C24,18.6168 18.6168,24 12,24 C5.3832,24 0,18.6168 0,12 C0,5.3832 5.3832,0 12,0 Z M12,2 C6.48571429,2 2,6.48571429 2,12 C2,17.5142857 6.48571429,22 12,22 C17.5142857,22 22,17.5142857 22,12 C22,6.48571429 17.5142857,2 12,2 Z M13,17 C13,18.3333333 11,18.3333333 11,17 C11,15.6666667 13,15.6666667 13,17 Z M12.1051514,6 C13.5640667,6 15.3157925,6.84808275 15.8406414,8.467002 C16.3492393,10.0311188 15.5655166,11.7672624 14.5483079,12.4794708 C13.1966563,13.4246613 13.0502672,13.8580436 13.0502672,14.0012504 C13.0477433,14.5541843 12.5972074,15 12.0393717,15 C11.4816629,15 11.0298631,14.5541524 11.0298631,14.0037052 C11.0298631,12.6761729 12.218713,11.66872 13.3797777,10.8555144 C13.7407265,10.6027123 14.1395406,9.76459857 13.9174208,9.07719311 C13.6978242,8.39849099 12.8232343,7.99376915 12.1038568,7.99376915 C11.3150791,7.99376915 10.3382688,8.35491047 9.95712738,9.36736863 C9.76277335,9.88293867 9.17972416,10.1444537 8.65849375,9.95390447 C8.13600331,9.76212465 7.86845796,9.18928464 8.06408495,8.67247126 C8.67490638,7.049822 10.2600504,6 12.1026272,6 Z"
        id="Combined-Shape"
        fill="currentColor"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);
